import { successNotifyService, failureNotifyService } from "@/services/errors.service.js";
import { isInteger } from "core-js/fn/number";
import { isBoolean } from "lodash";

export function checkInputFieldService(localData, action) {
    let cfObj = {};

    //////////////////////////////////////
    /// About Component
    //////////////////////////////////////

    if (action === "saveFirstName" && localData.firstName) {
        cfObj.fieldName = 'firstName';
        cfObj.fieldValueIsNull = false;
        cfObj.collectionName = 'users';
        cfObj.vuexServiceName = 'users';
        return cfObj;

    } else if (action === "saveLastName" && localData.lastName) {
        cfObj.fieldName = 'lastName';
        cfObj.fieldValueIsNull = false;
        cfObj.collectionName = 'users';
        cfObj.vuexServiceName = 'users';
        return cfObj;

    } else if (action === "saveDob" && localData.dob) {
        cfObj.fieldName = 'dob';
        cfObj.fieldValueIsNull = false;
        cfObj.collectionName = 'users';
        cfObj.vuexServiceName = 'users';
        return cfObj;

    } else if (action === "saveGender" && localData.gender) {
        cfObj.fieldName = 'gender';
        cfObj.fieldValueIsNull = false;
        cfObj.collectionName = 'users';
        cfObj.vuexServiceName = 'users';
        return cfObj;

    } else if (action === "saveAbout" && localData.about) {
        cfObj.fieldName = 'about';
        cfObj.fieldValueIsNull = false;
        cfObj.collectionName = 'users';
        cfObj.vuexServiceName = 'users';
        return cfObj;

    } else if (action === "saveProfession" && localData.profession) {
        cfObj.fieldName = 'profession';
        cfObj.fieldValueIsNull = false;
        cfObj.collectionName = 'users';
        cfObj.vuexServiceName = 'users';
        return cfObj;

    } else if (action === "saveCareerObjective" && localData.careerObjective) {
        cfObj.fieldName = 'careerObjective';
        cfObj.fieldValueIsNull = false;
        cfObj.collectionName = 'users';
        cfObj.vuexServiceName = 'users';
        return cfObj;

    } else if (action === "saveTemplateColorCode" && localData.templateColorCode) {
        cfObj.fieldName = 'templateColorCode';
        cfObj.fieldValueIsNull = false;
        cfObj.collectionName = 'users';
        cfObj.vuexServiceName = 'users';
        return cfObj;

    }
    
    else {
        cfObj.fieldName = null;
        cfObj.fieldValueIsNull = true;
        cfObj.collectionName = null;
        cfObj.vuexServiceName = null;
        return cfObj;
    }

}

export function saveInputFieldService(payload) {

    const isUserLoggedIn = payload.isUserLoggedIn;
    const action = payload.action;
    const currentThis = payload.currentThis;
    const localData = payload.localData;
    const userId = payload.userId;

    const cfObj = checkInputFieldService(localData, action);
    
    // // console.log(cfObj, payload);

    if (!isUserLoggedIn || cfObj.fieldValueIsNull) {
        return;
    }

    currentThis.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", true);

    // // console.log("executing...", localData);

    const fieldName = cfObj.fieldName;
    const vuexServiceName = cfObj.vuexServiceName;

    const dataObj = {};
    dataObj["_id"] = userId;
    dataObj['collectionName'] = cfObj.collectionName;

    if (localData[`${fieldName}`]) { // If field value is not null
        
        if(isInteger(localData[`${fieldName}`])) {
            dataObj[`${fieldName}`] = Number(localData[`${fieldName}`].toString().trim());
        } if(isBoolean(localData[`${fieldName}`])) {
            dataObj[`${fieldName}`] = Boolean(localData[`${fieldName}`].toString().trim());
        } else {
            dataObj[`${fieldName}`] = localData[`${fieldName}`].trim();
        }

    } else dataObj[`${fieldName}`] = null; // If field value is null

    // // console.log(dataObj);

    currentThis.$store
        .dispatch(`${vuexServiceName}/${action}`, dataObj)
        .then((res) => {
            currentThis.$store.commit(
                "editor/TOGGLE_SAVE_IN_PROGRESS",
                false
            );
            //// console.log(res);
        })
        .catch((err) => {
            throw err;
        });
}

export function updateImageService(payload) {

    const imgInput = payload.imgInput;
    const _id = payload._id;
    const currentThis = payload.currentThis;
    const maxSize = payload.maxSize; // In MB

    if (imgInput.target.files && imgInput.target.files[0]) {
        if (imgInput.target.files.length > 1) { // Minor bug fix: added .length
            return;
        }

        const parts = imgInput.target.files[0].name.split(".");
        const ext = parts[parts.length - 1].toLowerCase(); // added toLowerCase for safety

        //////////////////////////////////////////
        // Check for correct image file type
        //////////////////////////////////////////

        if (ext !== "jpg" && ext !== "jpeg" && ext !== "png") {
            const payloadError = {
                title: "Incorrect File Type",
                text: "Please upload a supported image file type, e.g. jpg, png, etc.",
                currentThis
            }
            failureNotifyService(payloadError);
            return;
        }

        //////////////////////////////////////////
        // Check for image file size
        //////////////////////////////////////////

        if (imgInput.target.files[0].size / (1024*1024) > maxSize) {
            const payloadError = {
                title: "Image File Size Exceeded",
                text: `The size of the profile picture should be less than ${maxSize}MB.`,
                currentThis
            }
            failureNotifyService(payloadError);
            return;
        }

        currentThis.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", true);

        currentThis.$vs.loading({
            container: "#upload-profile-picture",
            color: "primary",
            background: "white",
            scale: 0.45,
        });

        const reader = new FileReader();
        reader.onload = (e) => {
            const profilePictureData = e.target.result;
            const profilePictureUrl = _id + "-" + imgInput.target.files[0].name;

            const ppObj = {
                profilePictureData,
                profilePictureUrl,
            };

            currentThis.$store
                .dispatch("users/updateProfilePicture", {
                    ppObj,
                    _id,
                })
                .then((res) => {
                    // SUCCESS PATH
                    currentThis.localData.profilePictureUrl = res.data.profilePictureUrl;
                    
                    successNotifyService({
                        title: "Success",
                        text: "Profile picture updated successfully.",
                        currentThis
                    });
                    
                    currentThis.$forceUpdate();
                })
                .catch((err) => {
                    // ERROR PATH - FIX IS HERE
                    console.error("Backend failed to upload image:", err);
                    
                    // Show error notification instead of crashing
                    failureNotifyService({
                        title: "Upload Failed",
                        text: "The server encountered an error saving your image. Please try again.",
                        currentThis
                    });
                })
                .finally(() => {
                    // FINALLY PATH - This runs no matter if it succeeds or fails
                    // This ensures the UI never gets stuck loading
                    currentThis.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", false);
                    currentThis.$vs.loading.close("#upload-profile-picture > .con-vs-loading");
                });
        };
        reader.readAsDataURL(imgInput.target.files[0]);
    }
}